<ul
  [ngClass]="[
    'tile-layout-' + maxColumns,
    mobileThumbnails ? 'tile-layout-mobile' : '',
    isVertical ? 'vertical' : ''
  ]">
  <ng-content></ng-content>
</ul>
